/* BAMBUM Theme JS — GSAP ScrollTrigger + Mobile-Aware Reveals */

/* Let the browser restore scroll position naturally on back/forward navigation.
   Users who click an editorial card and hit back now return to exactly where the
   cards were, not the top of the page. Native browser behavior — same as Aesop, Rolex. */
if ('scrollRestoration' in history) history.scrollRestoration = 'auto';

(function(){
  'use strict';

  var IS_MOBILE = window.innerWidth < 768;
  var REDUCED   = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* Detect back/forward navigation. On return, entry animations should NOT re-fire —
     the user already saw them. Re-firing them as the scroll position restores causes
     a visible "vibration" because multiple sections translate from y:40 to y:0 at once. */
  var navEntries = performance.getEntriesByType ? performance.getEntriesByType('navigation') : [];
  var IS_BACK_FORWARD = navEntries.length > 0 && navEntries[0].type === 'back_forward';

  document.addEventListener('DOMContentLoaded', function() {

    /* Lenis — DESKTOP ONLY. iOS native scroll is already smooth; adding
       JS scroll layers on top of iOS momentum makes it WORSE, not better.
       This is the rule Aesop/Le Labo follow: don't fight the OS. */
    if (typeof Lenis !== 'undefined' && !IS_MOBILE && !REDUCED) {
      var lenis = new Lenis({
        duration: 1.1,
        easing: function(t){return Math.min(1, 1.001 - Math.pow(2, -10 * t));},
        wheelMultiplier: 1
      });
      function raf(time){ lenis.raf(time); requestAnimationFrame(raf); }
      requestAnimationFrame(raf);
      window.lenis = lenis;
    }

    /* ─── Eager-load every image at DOMContentLoaded ───
       Lazy-loading is the root cause of pop-in: images don't start
       downloading until they're near viewport, then the user is already
       past them. Force all images to start loading immediately so by
       the time the user scrolls, the bytes are already cached. ─── */
    initEagerLoadImages();

    /* Note: fade-in disabled. Letting browsers render progressive JPEGs
       natively as bytes arrive — that's how Aesop/Le Labo do it.
       Hard opacity 0→1 jumps look amateur on slow connections. */

    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      gsap.registerPlugin(ScrollTrigger);
      gsap.defaults({ force3D: true });
      if (REDUCED) {
        document.querySelectorAll('.img-reveal,.img-reveal-side,.img-reveal-up').forEach(function(el){
          el.style.clipPath = 'none'; el.style.opacity = '1'; el.style.transform = 'none';
        });
      } else if (IS_MOBILE) {
        /* Mobile: pure CSS opacity fade-in via IntersectionObserver. No translate, no GSAP.
           Translate animations fire DURING active scroll and cause visible section
           adjustment — the exact thing Dron felt. Pure opacity = zero perceived movement. */
        initMobileFadeIn();
      } else {
        initAnimations();
        initUniversalImageReveals();
      }
    }

    /* Anchor smooth-scroll: only kicks in when user CLICKS an anchor link.
       Global scroll-behavior:smooth was buffering scroll events and causing jumps. */
    document.addEventListener('click', function(e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a) return;
      var hash = a.getAttribute('href');
      if (hash.length < 2) return;
      var target = document.querySelector(hash);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.replaceState(null, '', hash);
    });

    initNavbar();
    initHeroEntrance();
    initReviews();
    initBrandCloser();
    initEmailPopup();
    initMobileCta();
    initInstantNav();
  });

  /* INSTANT.PAGE-style nav prefetch + page-fade-out on click.
     The fade-IN happens via CSS in theme.liquid <head> on every page load.
     This function adds: prefetch on touchstart/hover + fade-out before navigating. */
  function initInstantNav() {

    var prefetched = {};
    function preload(url) {
      if (prefetched[url]) return;
      prefetched[url] = true;
      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = url;
      link.as = 'document';
      document.head.appendChild(link);
    }
    function isInternalLink(a) {
      if (!a || !a.href) return false;
      try {
        var u = new URL(a.href, window.location.href);
        if (u.origin !== window.location.origin) return false;
        if (u.pathname === window.location.pathname) return false;
        if (u.pathname.indexOf('/cart') === 0) return false;
        if (u.pathname.indexOf('/checkout') === 0) return false;
        if (u.pathname.indexOf('/account') === 0) return false;
        return true;
      } catch(_) { return false; }
    }
    /* Touch-start prefetch (iOS) — fires the moment finger lands, before tap completes */
    document.addEventListener('touchstart', function(e){
      var a = e.target.closest && e.target.closest('a');
      if (isInternalLink(a)) preload(a.href);
    }, { passive: true, capture: true });
    /* Hover prefetch (desktop) */
    document.addEventListener('mouseover', function(e){
      var a = e.target.closest && e.target.closest('a');
      if (isInternalLink(a)) preload(a.href);
    });

    /* Fade-IN on every page load — opacity transition (works on iOS Safari, unlike body animation) */
    function fadeInPage(){ document.body.classList.add('bm-page-loaded'); }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fadeInPage);
    } else {
      requestAnimationFrame(fadeInPage);
    }

    /* Fade-OUT on click before navigating (no white flash, no premature snap) */
    document.addEventListener('click', function(e){
      if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      var a = e.target.closest && e.target.closest('a');
      if (!isInternalLink(a)) return;
      if (a.target && a.target !== '' && a.target !== '_self') return;
      if (a.hasAttribute('download')) return;
      e.preventDefault();
      var href = a.href;
      var navigated = false;
      function go(){ if (!navigated) { navigated = true; window.location.href = href; } }
      document.body.addEventListener('transitionend', function once(ev){
        if (ev.propertyName !== 'opacity') return;
        document.body.removeEventListener('transitionend', once);
        go();
      });
      document.body.classList.remove('bm-page-loaded');
      document.body.classList.add('bm-page-leaving');
      /* Hard fallback in case transitionend doesn't fire (180ms fade + 40ms safety) */
      setTimeout(go, 220);
    });
    /* Restore opacity on bfcache restore so the page isn't blank when user hits Back */
    window.addEventListener('pageshow', function(e){
      if (e.persisted) {
        document.body.classList.remove('bm-page-leaving');
        document.body.classList.add('bm-page-loaded');
      }
    });
  }


  /* ═══════════════════════════════════════════════
     SMARTER PRELOAD: convert lazy images to eager only
     when they're within ONE VIEWPORT of being seen. This
     prevents bandwidth from being split across 13 parallel
     downloads (which makes nothing load on slow connections),
     while still ensuring images are ready before user reaches them.
     ═══════════════════════════════════════════════ */
  function initEagerLoadImages() {
    /* Get out of the browser's way. Parent containers already reserve
       layout via Tailwind aspect-[4/3] etc. Adding aspect-ratio TO the
       <img> itself fights with `w-full h-full object-cover` and collapses
       images to a sliver. Just hint the browser to decode async. */
    document.querySelectorAll('main section img').forEach(function(img) {
      if (img.closest('#navbar')) return;
      if (!img.hasAttribute('decoding')) img.setAttribute('decoding', 'async');
    });
  }


  /* ═══════════════════════════════════════════════
     IMAGE FADE-IN: every image starts hidden, fades in
     when its bytes finish downloading.  Kills the "pop-in"
     that makes lazy-loaded images feel cheap on phone.
     ═══════════════════════════════════════════════ */
  function initImageFadeIn() {
    /* Disabled — see note in DOMContentLoaded handler. */
  }


  /* ═══════════════════════════════════════════════
     UNIVERSAL IMAGE REVEALS — all section images
     fade-up + clip-path. Lightweight on mobile (no scrub).
     ═══════════════════════════════════════════════ */
  function initUniversalImageReveals() {
    /* Disabled. The clip-path reveal effect was fragile on Shopify preview iframes and
       caused images to appear missing. Images now appear natively as the browser paints
       them — same pattern as Aesop, Le Labo, Glossier. Cleaner, faster, can never fail. */
    return;
  }


  /* ═══════════════════════════════════════════════
     MOBILE FADE-IN — opacity only, CSS transition, IntersectionObserver trigger.
     No JS animations during scroll. No translate. Sections never move position.
     Same approach Rolex, Aesop, Le Labo use on mobile.
     ═══════════════════════════════════════════════ */
  function initMobileFadeIn() {
    /* Skip the fade-in entirely on back/forward navigation. The user already saw
       these elements when they first visited the page — re-fading them on return
       reads as "vibration" or flicker. Native browser scroll restoration + instant
       visible content = clean back-navigation experience. */
    var navEntries = performance.getEntriesByType ? performance.getEntriesByType('navigation') : [];
    var isBackForward = navEntries.length > 0 && navEntries[0].type === 'back_forward';

    if (!document.getElementById('bm-fadein-style')) {
      var st = document.createElement('style');
      st.id = 'bm-fadein-style';
      st.textContent = (
        '.bm-fade{opacity:0;transition:opacity 0.9s cubic-bezier(0.4,0,0.2,1);}'
        + '.bm-fade.bm-fade-in{opacity:1;}'
      );
      document.head.appendChild(st);
    }

    /* Tag the inner content elements (text blocks, cards) — never the section container,
       because hiding the section would change page height during initial paint. */
    var selectors = [
      '.material-text','.diff-text','.diff-stat',
      '.cred-left','.cred-right',
      '.review-quote-mark','.review-label','.review-content','.review-dots',
      '.editorial-label','.editorial-card',
      '.ritual-heading','.ritual-orb','.ritual-caption'
    ];
    var targets = [];
    selectors.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(el) {
        el.classList.add('bm-fade');
        targets.push(el);
      });
    });

    if (isBackForward || !('IntersectionObserver' in window) || targets.length === 0) {
      /* Back/forward navigation OR no IO support — show everything immediately, no animation */
      targets.forEach(function(el) {
        el.style.transition = 'none';
        el.classList.add('bm-fade-in');
      });
      return;
    }

    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('bm-fade-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });

    targets.forEach(function(el) { io.observe(el); });
  }

  /* Handle bfcache hits — page restored from browser back-forward cache.
     Show all fade elements + clear any stale GSAP transform state so the page
     looks identical to how the user left it. */
  window.addEventListener('pageshow', function(e) {
    if (!e.persisted) return;
    /* Mobile fade-in elements */
    document.querySelectorAll('.bm-fade').forEach(function(el) {
      el.style.transition = 'none';
      el.classList.add('bm-fade-in');
    });
    /* Desktop GSAP-managed elements — force them to natural state */
    var desktopTargets = '.material-text,.diff-text,.diff-stat,.cred-left,.cred-right,'
      + '.review-quote-mark,.review-label,.review-content,.review-dots,'
      + '.editorial-label,.editorial-card,'
      + '.ritual-heading,.ritual-orb,.ritual-caption,'
      + '.img-reveal,.img-reveal-side,.gold-rule-animated';
    document.querySelectorAll(desktopTargets).forEach(function(el) {
      el.style.opacity = '1';
      el.style.transform = 'none';
      el.style.clipPath = 'none';
    });
  });


  /* ═══════════════════════════════════════════════
     GSAP SCROLL ANIMATIONS — section-specific
     Mobile guard on all parallax + scrub work.
     ═══════════════════════════════════════════════ */
  function initAnimations() {

    /* SHARED entry: OPACITY-ONLY fade, fast (0.6s), no translate.
       Previous version animated y:40 → 0 which made elements visibly slide as the
       user scrolled — distracting "shift" during reading. Pure opacity fade has
       zero perceived motion. The user just notices the element was there. */
    function entry(selector, opts) {
      var els = document.querySelectorAll(selector);
      if (!els.length) return;

      if (IS_BACK_FORWARD) {
        els.forEach(function(el){
          el.style.opacity = '1';
          el.style.transform = 'none';
        });
        return;
      }

      els.forEach(function(el){
        gsap.fromTo(el,
          { opacity: 0 },
          {
            opacity: 1,
            duration: 0.6,
            ease: 'power2.out',
            force3D: true,
            clearProps: 'opacity,willChange',
            stagger: opts && opts.to && opts.to.stagger ? opts.to.stagger : 0,
            scrollTrigger: {
              trigger: el,
              start: opts && opts.start ? opts.start : 'top 92%',
              once: true
            }
          }
        );
      });
    }

    /* Hero parallax — scrub-based, desktop only (scrub keeps main thread busy on mobile) */
    var heroSection = document.getElementById('hero-section');
    if (heroSection && !IS_MOBILE) {
      gsap.to('#hero-img-wrap', { yPercent: 25, scale: 1.15, ease: 'none', force3D: true,
        scrollTrigger: { trigger: heroSection, start: 'top top', end: 'bottom top', scrub: 1.2 }});
      gsap.to('#hero-content', { y: -80, opacity: 0, ease: 'none', force3D: true,
        scrollTrigger: { trigger: heroSection, start: '20% top', end: '80% top', scrub: 0.8 }});
    }

    /* Image clip-path reveals — desktop only, and only on fresh navigation */
    if (!IS_MOBILE) {
      if (IS_BACK_FORWARD) {
        /* User already saw these reveals — show images at natural state */
        document.querySelectorAll('.img-reveal, .img-reveal-side').forEach(function(el){
          el.style.clipPath = 'none';
          el.style.transform = 'none';
        });
      } else {
        document.querySelectorAll('.img-reveal').forEach(function(el){
          gsap.to(el, { clipPath: 'inset(0% 0 0% 0)', scale: 1, duration: 1.8, ease: 'power4.inOut', force3D: true,
            scrollTrigger: { trigger: el, start: 'top 82%', once: true }});
        });
        document.querySelectorAll('.img-reveal-side').forEach(function(el){
          gsap.to(el, { clipPath: 'inset(0 0 0 0%)', scale: 1, duration: 1.8, ease: 'power4.inOut', force3D: true,
            scrollTrigger: { trigger: el, start: 'top 82%', once: true }});
        });
      }
    }

    /* Section parallax — scrub-based, desktop only */
    if (!IS_MOBILE) {
      gsap.to('.material-img', { yPercent: -18, ease: 'none', force3D: true,
        scrollTrigger: { trigger: '#the-material', start: 'top bottom', end: 'bottom top', scrub: 1 }});
      gsap.to('.diff-img', { yPercent: -15, ease: 'none', force3D: true,
        scrollTrigger: { trigger: '#the-difference', start: 'top bottom', end: 'bottom top', scrub: 1 }});
    }

    /* ENTRY ANIMATIONS — run on BOTH desktop AND mobile. Each fires once when its
       trigger crosses 88% viewport, then GSAP releases the layer. */
    entry('.material-text');
    entry('.diff-text');
    entry('.diff-stat', { from: { opacity: 0, y: 20, scale: 0.95 }, to: { stagger: 0.18 } });
    entry('.cred-left', { from: { opacity: 0, x: IS_MOBILE ? 0 : -40, y: IS_MOBILE ? 30 : 0 }, to: { stagger: 0.18 } });
    entry('.cred-right', { from: { opacity: 0, x: IS_MOBILE ? 0 : 40, y: IS_MOBILE ? 30 : 0 }, to: { stagger: 0.18 } });

    /* Lifestyle parallax — desktop only */
    if (!IS_MOBILE) {
      gsap.to('.lifestyle-img', { yPercent: -12, ease: 'none', force3D: true,
        scrollTrigger: { trigger: '#lifestyle', start: 'top bottom', end: 'bottom top', scrub: 1 }});
    }

    /* Reviews entrance — runs on both desktop and mobile via the entry() helper */
    entry('.review-quote-mark', { from: { opacity: 0, x: -30 }, to: { duration: 1.4, start: 'top 85%' } });
    entry('.review-label',      { from: { opacity: 0, y: 10 }, to: { delay: 0.2, duration: 1.2, start: 'top 85%' } });
    entry('.review-content',    { from: { opacity: 0, y: 30 }, to: { delay: 0.35, duration: 1.4, start: 'top 85%' } });
    entry('.review-dots',       { from: { opacity: 0 }, to: { delay: 0.6, duration: 1, start: 'top 85%' } });

    /* Editorial entrance */
    entry('.editorial-label', { from: { opacity: 0, x: -20 }, to: { start: 'top 90%' } });
    entry('.editorial-card',  { from: { opacity: 0, y: 40 }, to: { stagger: 0.12, start: 'top 88%' } });

    /* Ritual entrance */
    entry('.ritual-heading', { from: { opacity: 0, y: 25 }, to: { duration: 1.4 } });
    entry('.ritual-orb', { from: { opacity: 0, scale: 0.85, y: 0 }, to: { stagger: 0.12, ease: 'back.out(1.3)' } });
    entry('.ritual-caption', { from: { opacity: 0, y: 12 }, to: { delay: 0.4 } });

    /* Bamboo decoration parallax — desktop only, scrub-based */
    if (!IS_MOBILE) {
      document.querySelectorAll('.bamboo-deco').forEach(function(el){
        gsap.to(el, { yPercent: -20, ease: 'none', force3D: true,
          scrollTrigger: { trigger: el.closest('section') || el.closest('footer'),
            start: 'top bottom', end: 'bottom top', scrub: 2 }});
      });
    }

    /* FAQ gold rules — one-shot, transform: scaleX */
    if (IS_BACK_FORWARD) {
      document.querySelectorAll('.gold-rule-animated').forEach(function(el){
        el.style.transform = 'scaleX(1)';
      });
    } else {
      document.querySelectorAll('.gold-rule-animated').forEach(function(el){
        gsap.to(el, { scaleX: 1, duration: 1.2, ease: 'power3.inOut', force3D: true,
          scrollTrigger: { trigger: el, start: 'top 90%', once: true }});
      });
    }
  }


  /* ═══════════════════════════════════════════════
     NAVBAR
     ═══════════════════════════════════════════════ */
  function initNavbar() {
    var navbar = document.getElementById('navbar');
    var logoImg = document.getElementById('logo-img');
    var logoGlow = document.getElementById('logo-glow');
    var logoLink = document.getElementById('logo-link');
    if (!navbar) return;

    var scrolled = false, atTop = true;
    function updateNav() {
      var sy = window.scrollY;
      var newScrolled = sy > 50, newAtTop = sy < 10;
      if (newScrolled !== scrolled) {
        scrolled = newScrolled;
        if (scrolled) {
          navbar.classList.remove('bg-transparent');
          // Solid bg on mobile (backdrop-filter:blur is the #1 mobile scroll-killer in iOS Safari)
          navbar.style.backgroundColor = IS_MOBILE ? 'rgb(250,247,242)' : 'rgba(250,247,242,0.95)';
          if (!IS_MOBILE) {
            navbar.style.backdropFilter = 'blur(12px)';
            navbar.style.webkitBackdropFilter = 'blur(12px)';
          }
          navbar.style.boxShadow = '0 1px 0 rgba(0,0,0,0.05)';
        } else {
          navbar.classList.add('bg-transparent');
          navbar.style.backgroundColor = '';
          navbar.style.backdropFilter = '';
          navbar.style.webkitBackdropFilter = '';
          navbar.style.boxShadow = '';
        }
      }
      if (newAtTop !== atTop) { atTop = newAtTop; updateNavColors(); }
    }
    function updateNavColors() {
      var els = navbar.querySelectorAll('.nav-text-color');
      els.forEach(function(el){ el.style.color = atTop ? 'rgba(250,247,242,0.95)' : 'rgba(30,58,47,0.85)'; });
    }
    if (logoLink) {
      logoLink.addEventListener('mouseenter', function(){
        if (logoGlow) { logoGlow.style.background = 'radial-gradient(circle, rgba(184,150,90,0.18) 0%, transparent 70%)'; logoGlow.style.transform = 'scale(2.2)'; }
        if (logoImg) { logoImg.style.filter = 'drop-shadow(0 0 8px rgba(184,150,90,0.5))'; logoImg.style.transform = 'scale(1.12)'; }
      });
      logoLink.addEventListener('mouseleave', function(){
        if (logoGlow) { logoGlow.style.background = 'radial-gradient(circle, rgba(184,150,90,0) 0%, transparent 70%)'; logoGlow.style.transform = 'scale(1)'; }
        if (logoImg) { logoImg.style.filter = 'none'; logoImg.style.transform = 'scale(1)'; }
      });
    }
    // Throttle scroll handler to one rAF tick — stops it firing 60+ times per second on mobile
    var navTicking = false;
    function onNavScroll() {
      if (!navTicking) {
        requestAnimationFrame(function(){ updateNav(); navTicking = false; });
        navTicking = true;
      }
    }
    window.addEventListener('scroll', onNavScroll, { passive: true });
    updateNav(); updateNavColors();
  }


  /* ═══════════════════════════════════════════════
     HERO ENTRANCE
     ═══════════════════════════════════════════════ */
  function initHeroEntrance() {
    var bgImg = document.getElementById('hero-bg-img');
    if (bgImg) {
      var isMobile = window.innerWidth < 768;
      setTimeout(function(){ bgImg.style.opacity = isMobile ? '0.55' : '0.35'; bgImg.style.transform = 'scale(1)'; }, 100);
    }
    document.querySelectorAll('.hero-word').forEach(function(word, i){
      setTimeout(function(){
        word.style.transition = 'transform 1.1s cubic-bezier(0.16, 1, 0.3, 1)';
        word.style.transform = 'translateY(0)';
      }, 500 + i * 120);
    });
    document.querySelectorAll('.hero-entrance').forEach(function(el){
      var delay = parseInt(el.getAttribute('data-delay') || '0', 10);
      setTimeout(function(){ el.style.opacity = '1'; el.style.transform = 'translateY(0) scale(1)'; }, delay);
    });
  }


  /* ─── Reviews carousel + Brand closer + FAQ + Email popup + Mobile CTA (unchanged) ─── */
  var _reviewIndex = 0, _reviewTimer = null, _reviewCount = 3;
  window.setReview = function(i) {
    _reviewIndex = i;
    document.querySelectorAll('.review-slide').forEach(function(slide){
      slide.style.opacity = parseInt(slide.getAttribute('data-slide')) === i ? '1' : '0';
    });
    /* Reset all progress bars using transform: scaleX (GPU-composited, no paint/layout cost).
       Was previously animating `width` — that triggers layout 60fps and was a major
       contributor to scroll jitter on mobile because the bar runs forever in the background. */
    document.querySelectorAll('.review-dot').forEach(function(dot){
      var bar = dot.querySelector('.review-bar');
      if (bar) { bar.style.transition = 'none'; bar.style.transform = 'scaleX(0)'; bar.style.transformOrigin = 'left center'; }
    });
    var activeDot = document.querySelector('.review-dot[data-index="' + i + '"]');
    if (activeDot) {
      var bar = activeDot.querySelector('.review-bar');
      if (bar) {
        bar.style.transformOrigin = 'left center';
        bar.style.transition = 'none';
        bar.style.transform = 'scaleX(0)';
        requestAnimationFrame(function(){
          bar.style.transition = 'transform 5s linear';
          bar.style.transform = 'scaleX(1)';
        });
      }
    }
    clearInterval(_reviewTimer);
    _reviewTimer = setInterval(function(){ window.setReview((_reviewIndex + 1) % _reviewCount); }, 5000);
  };
  function initReviews() {
    var slides = document.querySelectorAll('.review-slide');
    if (slides.length === 0) return;
    _reviewCount = slides.length;
    /* Tap anywhere on the quote to advance, and swipe on touch devices.
       Touch and click both fire on phones, so a flag suppresses the duplicate. */
    var stage = document.querySelector('.review-slide') && document.querySelector('.review-slide').parentElement;
    if (stage && !stage.dataset.bmSwipe) {
      stage.dataset.bmSwipe = '1';
      stage.style.cursor = 'pointer';
      stage.style.touchAction = 'pan-y';
      var sx = 0, sy = 0, moved = false, touchedAt = 0;
      function step(dir) {
        window.setReview((_reviewIndex + dir + _reviewCount) % _reviewCount);
      }
      stage.addEventListener('touchstart', function(e){
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; moved = false;
      }, { passive: true });
      stage.addEventListener('touchmove', function(e){
        if (Math.abs(e.touches[0].clientX - sx) > 10) moved = true;
      }, { passive: true });
      stage.addEventListener('touchend', function(e){
        touchedAt = Date.now();
        if (e.target.closest('.review-dot')) return;
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy)) {
          step(dx < 0 ? 1 : -1);
        } else if (!moved) {
          step(1);
        }
      }, { passive: true });
      stage.addEventListener('click', function(e){
        if (Date.now() - touchedAt < 700) return;   /* touch already handled it */
        if (e.target.closest('.review-dot')) return;
        step(1);
      });
    }
    /* Force bars to use scaleX so width never animates */
    document.querySelectorAll('.review-bar').forEach(function(bar){
      bar.style.width = '100%';
      bar.style.transformOrigin = 'left center';
      bar.style.transform = 'scaleX(0)';
    });
    /* Pause carousel when not in viewport — no point running a timer if the user is not looking */
    var reviewSection = document.getElementById('reviews-section');
    if (reviewSection && 'IntersectionObserver' in window) {
      var paused = true;
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting && paused) {
            paused = false;
            window.setReview(_reviewIndex);
          } else if (!e.isIntersecting && !paused) {
            paused = true;
            clearInterval(_reviewTimer);
          }
        });
      }, { threshold: 0.15 });
      io.observe(reviewSection);
    } else {
      window.setReview(0);
    }
  }

  var _bcIndex = 0, _bcTimer = null, _bcCount = 3;
  window._bcPaused = false;
  window.setBcQuote = function(i) {
    _bcIndex = i;
    document.querySelectorAll('.bc-slide').forEach(function(slide){ slide.style.opacity = parseInt(slide.getAttribute('data-slide')) === i ? '0.65' : '0'; });
    document.querySelectorAll('.bc-dot').forEach(function(dot, idx){
      var inner = dot.querySelector('div');
      if (inner) inner.className = idx === i ? 'h-1.5 rounded-full transition-all duration-700 bg-gold w-10' : 'h-1.5 rounded-full transition-all duration-700 bg-ink/10 w-1.5 hover:bg-ink/20';
    });
  };
  function initBrandCloser() {
    var slides = document.querySelectorAll('.bc-slide');
    if (slides.length === 0) return;
    _bcCount = slides.length;
    /* Only run the carousel timer when the section is on screen — main thread stays
       idle during scroll if the user is nowhere near this section. */
    var bcSection = document.getElementById('brand-closer');
    function start(){ if(!_bcTimer){ _bcTimer = setInterval(function(){ if (!window._bcPaused) window.setBcQuote((_bcIndex + 1) % _bcCount); }, 6000); } }
    function stop(){ clearInterval(_bcTimer); _bcTimer = null; }
    if (bcSection && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if(e.isIntersecting){ start(); } else { stop(); } });
      }, { threshold: 0.15 });
      io.observe(bcSection);
    } else { start(); }
  }

  window.toggleFaq = function(btn) {
    var content = btn.nextElementSibling, chevron = btn.querySelector('.faq-chevron');
    var isOpen = btn.getAttribute('aria-expanded') === 'true';
    document.querySelectorAll('[aria-expanded="true"]').forEach(function(other){
      if (other !== btn) {
        other.setAttribute('aria-expanded', 'false');
        other.nextElementSibling.style.maxHeight = '0';
        other.nextElementSibling.style.paddingBottom = '0';
        var oc = other.querySelector('.faq-chevron'); if (oc) oc.style.transform = 'rotate(0deg)';
      }
    });
    if (isOpen) {
      btn.setAttribute('aria-expanded', 'false'); content.style.maxHeight = '0';
      if (chevron) chevron.style.transform = 'rotate(0deg)';
    } else {
      btn.setAttribute('aria-expanded', 'true'); content.style.maxHeight = content.scrollHeight + 'px';
      if (chevron) chevron.style.transform = 'rotate(180deg)';
    }
  };

  function initEmailPopup() {
    /* 2026-07-11: no scroll auto-open on the commercial path (home, PDPs, first-box). Footer + Chapter II capture remain. */
    var p = location.pathname;
    if (p === '/' || p.indexOf('/products/') === 0 || p.indexOf('first-box') !== -1) return;
    if (sessionStorage.getItem('bambum-popup-dismissed')) return;
    var popup = document.getElementById('email-popup'); if (!popup) return;

    /* Trigger at 55% scroll depth — meaningful engagement signal (user is reading) but well
       before they hit the footer. Works on homepage AND product pages alike (any page that
       includes the popup snippet — currently theme.liquid renders it on every page). */
    var triggered = false;
    var minDelay = false;
    setTimeout(function(){ minDelay = true; }, 6000);

    function maybeOpen() {
      if (triggered || !minDelay) return;
      var docH = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
      var visibleH = window.innerHeight;
      var scrollTop = window.scrollY || document.documentElement.scrollTop;
      var scrollable = Math.max(1, docH - visibleH);
      var pct = scrollTop / scrollable;
      if (pct >= 0.55) {
        triggered = true;
        window.openPopup();
        window.removeEventListener('scroll', onScroll);
      }
    }

    var rafQueued = false;
    function onScroll() {
      if (rafQueued) return;
      rafQueued = true;
      requestAnimationFrame(function(){ maybeOpen(); rafQueued = false; });
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    /* Exit-intent fallback on desktop — if user never reaches 55%, still catch them on hover-out */
    document.addEventListener('mouseleave', function(e){
      if (!triggered && minDelay && e.clientY <= 0) {
        triggered = true;
        window.openPopup();
      }
    });
  }
  window.openPopup = function() {
    var popup = document.getElementById('email-popup'), backdrop = document.getElementById('popup-backdrop'), card = document.getElementById('popup-card');
    if (!popup) return;
    popup.style.visibility = 'visible';
    requestAnimationFrame(function(){
      if (backdrop) backdrop.style.opacity = '1';
      if (card) { card.style.opacity = '1'; card.style.transform = 'translateY(0) scale(1)'; }
    });
  };
  window.closePopup = function() {
    var backdrop = document.getElementById('popup-backdrop'), card = document.getElementById('popup-card'), popup = document.getElementById('email-popup');
    if (backdrop) backdrop.style.opacity = '0';
    if (card) { card.style.opacity = '0'; card.style.transform = 'translateY(6px) scale(0.97)'; }
    setTimeout(function(){ if (popup) popup.style.visibility = 'hidden'; }, 650);
    sessionStorage.setItem('bambum-popup-dismissed', 'true');
  };

  function initMobileCta() {
    var cta = document.getElementById('mobile-cta'); if (!cta || window.innerWidth >= 640) return;

    /* IO on a sentinel at 80vh — fires once when crossed, never reads scroll position
       on the main thread. Replaces a high-frequency scroll listener that was contributing
       to mobile scroll jitter. */
    if (!('IntersectionObserver' in window)) return;
    var sentinel = document.createElement('div');
    sentinel.style.cssText = 'position:absolute;left:0;width:1px;height:1px;pointer-events:none;top:' + (window.innerHeight * 0.8) + 'px;';
    sentinel.setAttribute('aria-hidden', 'true');
    document.body.appendChild(sentinel);

    function show(){
      cta.style.opacity = '1';
      cta.style.pointerEvents = 'auto';
      cta.style.transform = 'translateX(-50%) translateY(0)';
    }
    function hide(){
      cta.style.opacity = '0';
      cta.style.pointerEvents = 'none';
      cta.style.transform = 'translateX(-50%) translateY(20px)';
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (!e.isIntersecting && e.boundingClientRect.top < 0) show();
        else hide();
      });
    });
    io.observe(sentinel);
  }

})();
